module.exports = __webpack_public_path__ + "media/images/icon-youtube-white-3febb2d1ce99c34a2a3ab5ddb9400cc4.svg";